<template>
    <div>
        <!-- Modal Anexos -->
		<div class="modal fade" :id="modal" tabindex="-1" role="dialog" aria-labelledby="orgModalLabel" aria-hidden="true" data-keyboard="false">
            <div class="modal-dialog modal-dialog2 modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content2" v-if="anexos">
                    <div class="modal-header" v-if="false">
                        <h5 class="modal-title" id="orgModalLabel">Arquivos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body" @keydown.up="navegar(true)" @keydown.down="navegar()">
                        <div class="form-row">
                            <div class="col col-12">
                                <div class="input-group input-group-sm mb-2">
                                    <input type="text" class="form-control" placeholder="Pesquisar..." v-model="search">
                                    <div class="input-group-append">
                                        <div class="dropdown">
                                            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ modo_view ? modo_view : '?' }}
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('1')">Lista / Seleção</a>
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('R')">Lista / Rolagem</a>
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('2')">2 Colunas</a>
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('3')">3 Colunas</a>
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('4')">4 Colunas</a>
                                                <a class="dropdown-item" href="#" @click.prevent="set_modo('6')">6 Colunas</a>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-outline-secondary" @click="ver_lateral('L')">
                                            <i class="fa-solid fa-right-to-line"></i>
                                        </button>
                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="fechar_modal()">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Visualização em Grade -->
                        <div v-if="modo_view > 1 || modo_view == 'R'">
                            <div class="form-row">
                                <div class="col col-12" :class="'col-md-' + ( 12 / ( modo_view == 'R' ? 1 : modo_view ) )" v-for="(item_lista, iix) in lista_exibicao" :key="iix">
                                    <pre v-if="false">{{ item_lista }}</pre>
                                    <div :src="item_lista ? item_lista.arquivo.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-if="item_lista && item_lista.arquivo && ( is_image(item_lista.arquivo) || modo_view == 'R' )">
                                        <az-input 
                                            type="checkbox-group"
                                            sizing="sm"
                                            :label="item_lista.arquivo.st_titulo"
                                            v-model="item_lista.fl_key"
                                            @click="atualizar_key(item_lista)">
                                            <template v-slot:buttonposcb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_imagem(item_lista)" :disabled="$store.state.loading">
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>

                                        <viewer :images="[item_lista.arquivo.temporary_url]" v-if="is_image(item_lista.arquivo)">
                                            <figure class="figure">
                                                <img :src="item_lista.arquivo.temporary_url" class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;">
                                            </figure>
                                        </viewer>

                                        <iframe :src="link_office(item_lista.arquivo)" style="width: 100%; height: 600px; border: none;" v-else-if="selecionado && is_office(selecionado)">
                                            Oops! ocorreu um erro ao abrir o arquivo.
                                        </iframe>

                                        <iframe :src="item_lista.arquivo.temporary_url" style="width: 100%; height: 600px; border: none;" v-else>
                                            Oops! ocorreu um erro ao abrir o arquivo.
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Visualização em Lista -->
                        <div class="form-row" v-else>
                            <div class="col col-12 col-md-2">
                                <div class="card overflow-auto bg-light card-fixo">
                                    <div class="list-group">
                                        <div v-if="!lista.length" class="list-group-item">
                                            Nenhum arquivo encontrado.
                                        </div>

                                        <template v-for="(group, key, iix) in lista_agrupada">
                                            <div class="list-group-item list-group-item-primary d-flex justify-content-between py-2" :key="'G' + iix" v-if="true">
                                                <div v-if="key && key != 'null' && key != 'undefined'">
                                                    <a href="#" @click.prevent="selecionar_pesquisa(key)">
                                                        {{ key }}
                                                    </a>
                                                </div>
                                                <div v-else>
                                                    Outros Arquivos
                                                </div>
                                                <div>
                                                    <span class="badge badge-primary">{{ group.length }}</span>
                                                </div>
                                            </div>

                                            <button type="button" class="list-group-item list-group-item-action" v-for="(flb, ifx) in group" 
                                                :class="( selecionado && selecionado.id_arquivo == flb.arquivo.id_arquivo ) ? 'active' : ''"
                                                :key="iix + '.' + ifx" @click="selecionado = flb.arquivo">
                                                <div>
                                                    {{ flb.arquivo.st_titulo }}
                                                </div>
                                                <div class="small" :class="( selecionado && selecionado.id_arquivo == flb.arquivo.id_arquivo ) ? '' : 'text-muted'" v-if="flb.arquivo.created_at">
                                                    {{ $util.getFormatDate(flb.arquivo.created_at) }}
                                                    {{ flb.arquivo.created_at.substr(11,5) }}
                                                </div>
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-10">
                                <div class="card overflow-auto bg-light card-fixo">
                                    <div :src="selecionado ? selecionado.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-if="selecionado && is_image(selecionado)">
                                        <viewer :images="[selecionado.temporary_url]">
                                            <figure class="figure">
                                                <img :src="selecionado.temporary_url" class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;">
                                            </figure>
                                        </viewer>
                                    </div>

                                    <iframe :src="link_office(selecionado)" style="width: 100%;height: 100%; border: none;" v-else-if="selecionado && is_office(selecionado)">
                                        Oops! ocorreu um erro ao abrir o arquivo.
                                    </iframe>

                                    <iframe :src="selecionado ? selecionado.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-else>
                                        Oops! ocorreu um erro ao abrir o arquivo.
                                    </iframe>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Fixo na lista lateral -->
        <div class="sticky-sidebar-right bg-white w3-animate-left" style="width: 300px;" v-if="ver_lista_lateral">
            <div class="form-row">
                <div class="col col-12 px-2">
                    <div class="input-group input-group-sm mb-2">
                        <input type="text" class="form-control" placeholder="Pesquisar..." v-model="search">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="ver_lista_lateral = false">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col col-12" v-for="(item_lista, iix) in lista_exibicao" :key="iix">
                    <div :src="item_lista ? item_lista.arquivo.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-if="item_lista && item_lista.arquivo">
                        <az-input 
                            type="checkbox-group"
                            sizing="sm"
                            :label="item_lista.arquivo.st_titulo"
                            v-model="item_lista.fl_key"
                            @click="atualizar_key(item_lista)">
                            <template v-slot:buttonposcb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_imagem(item_lista)" :disabled="$store.state.loading">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <viewer :images="[item_lista.arquivo.temporary_url]" v-if="is_image(item_lista.arquivo)">
                            <figure class="figure">
                                <img :src="item_lista.arquivo.temporary_url" class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;">
                            </figure>
                        </viewer>

                        <iframe :src="link_office(item_lista.arquivo)" style="width: 100%; height: 600px; border: none;" v-else-if="selecionado && is_office(selecionado)">
                            Oops! ocorreu um erro ao abrir o arquivo.
                        </iframe>

                        <iframe :src="item_lista.arquivo.temporary_url" style="width: 100%; height: 600px; border: none;" v-else>
                            Oops! ocorreu um erro ao abrir o arquivo.
                        </iframe>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../forms/AzInput.vue';

export default {
    data() {
        return { 
            anexos: null, 
            selecionado: null, 
            search: "", 
            modal: "anexoVerModal",
            modo_view: '1', 
            ver_lista_lateral: false, 
        }
    },

    components: { 
        AzInput,
    },

    computed: { 
      lista_exibicao: function () { 
        return this.lista.filter(ita => this.is_image(ita.arquivo) || this.modo_view == 'R' || this.ver_lista_lateral);
      },
      
      lista: function () { 
        if ( !this.anexos )
          return [];

        let pesquisar = this.search.trim();
        let parts = pesquisar.replace(' ','.*');
        let match = parts;
        let reg = new RegExp(match, 'i');

        return this.anexos.filter(item => item.id_arquivo_link && ( !this.search || reg.test(JSON.stringify(item))) );
      },

      lista_agrupada: function () { 
        return _.groupBy(this.lista, 'arquivo.st_tipo_arquivo');
      }
    },

    methods: { 
        ver_lateral () { 
            $('.modal').modal('hide');
            this.ver_lista_lateral = true; 
        },

        remover_imagem (arq) { 
            if ( !confirm('Confirma remover?') ) { 
                return;
            }

            this.$util.atualizar(this, {
                service: "arquivos",
                func: "destroy",
                dados: {
                    id: arq.id_arquivo_link
                },
                callback: () => {
                    this.$emit("refresh", arq.id_arquivo_link);
                    arq.id_arquivo_link = null;
                }
            });
        },

        atualizar_key(arquivo_link) { 
            this.$nextTick(() => { 
                setTimeout(() => { 
                    this.$util.atualizar(this, { 
                        service: 'arquivo_links',
                        dados: arquivo_link, 
                        callback: () => { 
                            this.$emit('refresh', arquivo_link.id_arquivo_link);
                        }
                    }),
                    200
                });
            });
        },

        set_modo (modo) { 
            this.modo_view = modo ? modo : '1';

            this.$util.setCookie('anexos-modo-view', this.modo_view);
        },

        is_image (arquivo) { 
            return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
        },

        is_office (arquivo) { 
            return arquivo.st_tipo_arquivo == 'docx' || arquivo.st_tipo_arquivo == 'xlsx' || arquivo.st_tipo_arquivo == 'pptx';
        },

        link_office(arquivo) { 
            return "https://view.officeapps.live.com/op/view.aspx?src=" 
                + encodeURIComponent(arquivo.temporary_url)
                + '&wdEmbedCode=0&wdPrint=0';
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        selecionar_pesquisa (key) { 
            if ( this.search == '"'+key+'"' ) { 
                this.search = "";
                return;
            }

            this.search = '"'+key+'"';
        },

        navegar (anterior = false) { 
            if ( !this.lista.length )
                return;

            if ( !this.selecionado ) { 
                this.selecionado = this.lista[0].arquivo;
                return;
            } else { 
                let idx = this.lista.findIndex(item => item.arquivo.id_arquivo == this.selecionado.id_arquivo);
                if ( anterior ) { 
                    if ( idx > 0 ) { 
                        this.arquivo = this.lista[idx - 1].arquivo;
                    }
                } else { 
                    if ( idx < this.lista.length - 1 ) { 
                        this.arquivo = this.lista[idx + 1].arquivo;
                    }
                }
            }
        },

        fechar_modal () { 
            $('#' + this.modal).modal('hide');
        },

        abrir(anexos, lateral = false) {
            this.anexos = _.cloneDeep(anexos);

            if ( anexos ) { 
                if ( lateral ) { 
                    $('.modal').modal('hide');
                    this.ver_lista_lateral = true; 
                } else { 
                    $('#' + this.modal).modal('show');
                }

                if ( this.lista.length ) { 
                    if ( this.selecionado && this.lista.find(item => item.arquivo.id_arquivo == this.selecionado.id_arquivo) )
                        return;

                    this.selecionado = this.lista[0].arquivo;
                }
            }
        },
    },

    mounted() { 
        this.modal = 'anexoVerModal' + this.uuidv4();

        let modo = this.$util.getCookie('anexos-modo-view');

        this.modo_view = modo ? modo : '1';
    }
}
</script>

<style scoped>
.bmd-btn-fab{
  position: fixed !important;
  top: 29px;
  right: 29px;
  z-index: 999;
}
.bmd-btn-fab{
  position: fixed !important;
  top: 170px;
  right: 20px;
  z-index: 999;
}

.modal-dialog2 {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100%;
  max-height: 100%;
  margin-top: 0px;
  margin-bottom: 0px;
}
.modal-content2 {
  height: 100% !important;
  max-height: 100% !important;
}

.card-fixo { 
  padding: 0px; 
  height: calc(100vh - 90px);
}

.sticky-sidebar-right {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 900; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}
</style>
